import React, { Component } from 'react'

export default class Info extends Component {
    render() {
        const {visibility, opacity} = this.props.popupProps;

        return (
            <div id="info" className="modal" 
                style={{visibility, opacity}}
                onClick={(e)=>{
                    if(e.target.id === "info")
                        this.props.resetProps();
                }}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <span className="close" onClick={this.props.resetProps}>&times;</span>
                        <h2>ATTENZIONE</h2>
                    </div>
                    <div className="modal-body">
                        <label align="justify"> 
                            {"Generalcavi S.p.A. declina ogni responsabilità per il malfunzionamento del presente software e per eventuali danni causati dall'utilizzo dello stesso."}
                            <br/>
                            {"L'applicazione non utilizza cookies."}
                            <br/>
                            {"© Tutti i diritti sono riservati. "}
                        </label>

                        <hr style={{ color: "black", paddingTop: "5px", width: "100%", height: "1px", border: "none", marginTop: "10px", marginBottom: "10px"}} />

                        <div className="credit">
                            <div className="credit-component">
                                <label
                                    style={{
                                        width:"100%",
                                        textAlign:"center",
                                        marginBottom: "5px",
                                    }}
                                >Distribuito da:</label>

                                <img 
                                    style={{height: "100px", maxWidth:"98%"}}
                                    src={"./images/logo-general-cavi.png"} 
                                    alt="" 
                                    loading="eager"
                                />
                            </div>

                            <div className="credit-component">
                                <label
                                    style={{
                                        width:"100%",
                                        textAlign:"center",
                                        marginBottom: "5px",
                                    }}
                                >Sviluppato da:</label>

                                <img
                                    style={{height: "100px", maxWidth:"98%"}}
                                    src={"./images/logo-eidos.png"} 
                                    alt="" 
                                    loading="eager"/>
                            </div>
                        </div>
                        <div style={{display: "flex", margin: "10px"}}>
                            <a href="mailto:webmaster@generalcavi.com" 
                                style={{
                                    width: "100%",
                                    textAlign: "center",
                                    marginTop: "5px"
                                }} 
                                className="ui-link">webmaster@generalcavi.com</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
